import type { AreaRoute } from "./areaRoute";
import { lazyPage } from "../../lib/lazyPage";
const SqdcPage = lazyPage(() => import("../shopfloor/SqdcPage"), "SqdcPage");
const CapacityPage = lazyPage(() => import("../shopfloor/CapacityPage"), "CapacityPage");
const DispatchPage = lazyPage(() => import("../shopfloor/DispatchPage"), "DispatchPage");
const HotlistPage = lazyPage(() => import("../shopfloor/HotlistPage"), "HotlistPage");
const MaterialPage = lazyPage(() => import("../shopfloor/MaterialPage"), "MaterialPage");
const WorkingNowPage = lazyPage(() => import("../shopfloor/WorkingNowPage"), "WorkingNowPage");
const OspBoardPage = lazyPage(() => import("../shopfloor/flow/OspBoardPage"), "OspBoardPage");
const ParkedWorkOrdersPage = lazyPage(() => import("../shopfloor/flow/ParkedWorkOrdersPage"), "ParkedWorkOrdersPage");

// Shop floor screens area (release 0.4.0), owned by the shop-floor agent: real pages for Dispatch, Capacity & machines,
// Material & OSP, Hotlist & holds, and Who's working; SqdcPage remains for P13.
export { CapacityPage, DispatchPage, HotlistPage, MaterialPage, SqdcPage, WorkingNowPage };

// Flow screens (release 0.4.1, D-O56) — owned by the wave-1 flow agent.
export { OspBoardPage, ParkedWorkOrdersPage };

export const shopFloorRoutes: AreaRoute[] = [];